import React, { useEffect, useState } from "react";
import axios from "axios";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

const CourageVideoTextEditor = () => {
  const [form, setForm] = useState({
    title1En: "",
    title1Ar: "",
    title1Ku: "",
    description1En: "",
    description1Ar: "",
    description1Ku: "",
    button1En: "",
    button1Ar: "",
    button1Ku: "",
    button2En: "",
    button2Ar: "",
    button2Ku: "",

    title2En: "",
    title2Ar: "",
    title2Ku: "",
    description2En: "",
    description2Ar: "",
    description2Ku: "",
  });

  const [videos, setVideos] = useState({ video1: null, video2: null });
  const [loading, setLoading] = useState(true);

  // Modal
  const [showModal, setShowModal] = useState(false);
  const [uploadFile, setUploadFile] = useState(null);
  const [uploadTarget, setUploadTarget] = useState(null);

  // ============================================================
  // FETCH ALL LANGUAGES
  // ============================================================
  useEffect(() => {
    const load = async () => {
      try {
        const [en, ar, ku] = await Promise.all([
          axios.get(`${API_BASE}/api/VoyahCourageVideoText?lang=en`),
          axios.get(`${API_BASE}/api/VoyahCourageVideoText?lang=ar`),
          axios.get(`${API_BASE}/api/VoyahCourageVideoText?lang=ku`),
        ]);

        setForm({
          // EN
          title1En: en.data.title1,
          description1En: en.data.desc1,   // FIXED
          button1En: en.data.button1,
          button2En: en.data.button2,
          title2En: en.data.title2,
          description2En: en.data.desc2,   // FIXED

          // AR
          title1Ar: ar.data.title1,
          description1Ar: ar.data.desc1,   // FIXED
          button1Ar: ar.data.button1,
          button2Ar: ar.data.button2,
          title2Ar: ar.data.title2,
          description2Ar: ar.data.desc2,   // FIXED

          // KU
          title1Ku: ku.data.title1,
          description1Ku: ku.data.desc1,   // FIXED
          button1Ku: ku.data.button1,
          button2Ku: ku.data.button2,
          title2Ku: ku.data.title2,
          description2Ku: ku.data.desc2,   // FIXED
        });

        setVideos({
          video1: en.data.video1,
          video2: en.data.video2,
        });

        setLoading(false);
      } catch (err) {
        console.error("Load error:", err);
      }
    };

    load();
  }, []);

  const resolveUrl = (u) => (u?.startsWith("http") ? u : `${API_BASE}${u}`);

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  // ============================================================
  // SAVE TEXT
  // ============================================================
  const handleSave = async () => {
    const token = localStorage.getItem("token");

    try {
      await axios.put(`${API_BASE}/api/VoyahCourageVideoText/1`, form, {
        headers: { Authorization: `Bearer ${token}` },
      });

      alert("Updated successfully");
    } catch (err) {
      console.error(err);
      alert("Update failed");
    }
  };

  // ============================================================
  // DELETE VIDEO
  // ============================================================
  const handleDeleteVideo = async (which) => {
    const token = localStorage.getItem("token");

    try {
      await axios.delete(
        `${API_BASE}/api/VoyahCourageVideoText/1/video?video=${which}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      alert("Deleted!");
      window.location.reload();
    } catch (err) {
      console.error(err);
      alert("Delete failed.");
    }
  };

  // ============================================================
  // UPLOAD NEW VIDEO
  // ============================================================
  const handleUpload = async () => {
    if (!uploadFile) return alert("Select a file first.");

    const token = localStorage.getItem("token");
    const fd = new FormData();
    fd.append(uploadTarget, uploadFile);

    try {
      await axios.post(`${API_BASE}/api/VoyahCourageVideoText/1/media`, fd, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });

      alert("Uploaded!");
      setShowModal(false);
      window.location.reload();
    } catch (err) {
      console.error(err);
      alert("Upload failed.");
    }
  };

  if (loading) return <p>Loading…</p>;

  return (
    <div className="container py-4">
      <h2 className="fw-bold mb-4">Courage Video & Text Section Editor</h2>

      {/* LANG FIELDS */}
      <div className="row">
        {["En", "Ar", "Ku"].map((lang) => (
          <div className="col-lg-4 col-md-6 mb-4" key={lang}>
            <div className="card shadow-sm h-100">
              <div className="card-body">
                <h5 className="text-primary">{lang} Version</h5>

                <label>Title 1</label>
                <input
                  className="form-control mb-2"
                  name={`title1${lang}`}
                  value={form[`title1${lang}`]}
                  onChange={handleChange}
                />

                <label>Description 1</label>
                <textarea
                  className="form-control mb-2"
                  rows={3}
                  name={`description1${lang}`}
                  value={form[`description1${lang}`]}
                  onChange={handleChange}
                />

                <label>Button 1</label>
                <input
                  className="form-control mb-2"
                  name={`button1${lang}`}
                  value={form[`button1${lang}`]}
                  onChange={handleChange}
                />

                <label>Button 2</label>
                <input
                  className="form-control mb-2"
                  name={`button2${lang}`}
                  value={form[`button2${lang}`]}
                  onChange={handleChange}
                />

                <hr />

                <label>Title 2</label>
                <input
                  className="form-control mb-2"
                  name={`title2${lang}`}
                  value={form[`title2${lang}`]}
                  onChange={handleChange}
                />

                <label>Description 2</label>
                <textarea
                  className="form-control mb-2"
                  rows={3}
                  name={`description2${lang}`}
                  value={form[`description2${lang}`]}
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* SAVE TEXT */}
      <div className="text-end mb-4">
        <button className="btn btn-primary px-5" onClick={handleSave}>
          Save All Text
        </button>
      </div>

      {/* VIDEO MANAGER */}
      <h3>Videos</h3>

      <table className="table table-bordered">
        <thead className="table-light">
          <tr>
            <th>Preview</th>
            <th>Type</th>
            <th style={{ width: "220px" }}>Actions</th>
          </tr>
        </thead>

        <tbody>
          {/* VIDEO 1 */}
          <tr>
            <td>
              {videos.video1 ? (
                <video
                  src={resolveUrl(videos.video1)}
                  className="w-100"
                  style={{ maxHeight: "200px" }}
                  controls
                />
              ) : (
                <p>No video</p>
              )}
            </td>
            <td>Video 1</td>
            <td className="d-flex flex-column gap-2">
              <button
                className="btn btn-danger btn-sm"
                onClick={() => handleDeleteVideo("video1")}
              >
                Delete
              </button>
              <button
                className="btn btn-primary btn-sm"
                onClick={() => {
                  setUploadTarget("video1");
                  setShowModal(true);
                }}
              >
                Replace
              </button>
            </td>
          </tr>

          {/* VIDEO 2 */}
          <tr>
            <td>
              {videos.video2 ? (
                <video
                  src={resolveUrl(videos.video2)}
                  className="w-100"
                  style={{ maxHeight: "200px" }}
                  controls
                />
              ) : (
                <p>No video</p>
              )}
            </td>
            <td>Video 2</td>
            <td className="d-flex flex-column gap-2">
              <button
                className="btn btn-danger btn-sm"
                onClick={() => handleDeleteVideo("video2")}
              >
                Delete
              </button>
              <button
                className="btn btn-primary btn-sm"
                onClick={() => {
                  setUploadTarget("video2");
                  setShowModal(true);
                }}
              >
                Replace
              </button>
            </td>
          </tr>
        </tbody>
      </table>

      {/* MODAL */}
      {showModal && (
        <>
          <div className="modal fade show" style={{ display: "block" }}>
            <div className="modal-dialog">
              <div className="modal-content shadow">
                <div className="modal-header">
                  <h5 className="modal-title">
                    Upload {uploadTarget === "video1" ? "Video 1" : "Video 2"}
                  </h5>
                  <button
                    className="btn-close"
                    onClick={() => setShowModal(false)}
                  ></button>
                </div>

                <div className="modal-body">
                  <input
                    type="file"
                    className="form-control"
                    accept="video/*"
                    onChange={(e) => setUploadFile(e.target.files[0])}
                  />
                </div>

                <div className="modal-footer">
                  <button
                    className="btn btn-secondary"
                    onClick={() => setShowModal(false)}
                  >
                    Cancel
                  </button>
                  <button className="btn btn-primary" onClick={handleUpload}>
                    Upload
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="modal-backdrop fade show"></div>
        </>
      )}
    </div>
  );
};

export default CourageVideoTextEditor;
